import React from 'react'
import styled from 'styled-components'
import { Box, Flex } from 'rebass/styled-components'

const SubNav = styled(Box)`
    background-color: ${(props) => props.theme.colors.aquaLight};
    display: none;
    font-size: ${(props) => props.theme.fontSizes.sm};
    height: 56px;
    padding-bottom: 0;
    padding-left: ${(props) => props.theme.space.sm};
    padding-right: ${(props) => props.theme.space.sm};
    padding-top: 0;
    position: absolute;
    top: 56px;
    width: 100%;
    z-index: 0;

    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        padding-left: ${(props) => props.theme.space.xs};
        padding-right: ${(props) => props.theme.space.xs};
    }

    &:hover,
    .active + &:hover {
        display: block;
        z-index: 99;
    }
    &:hover + a {
        font-weight: ${(props) => props.theme.fontWeights.bold};
    }
`

const Secondary = ({ children, align }) => {
    const orientation = align === 'right' ? 'flex-end' : 'flex-start'
    return (
        <SubNav
            className='subnav-container'
            sx={{
                left: 0,
            }}
        >
            <Flex
                alignContent='center'
                alignItems='center'
                height='100%'
                justifyContent={orientation}
            >
                {children}
            </Flex>
        </SubNav>
    )
}

export default Secondary
